// Imports for external libraries go here.
/* eslint-disable @nx/enforce-module-boundaries */
import { FC } from 'react';
import { TabContainerProps } from './TabContainer.types';
import { StyledTabContainer } from './TabContainer.styles';
import { EditableComponent } from '@adobe/aem-react-editable-components';
import { TabContainer } from '@marriott/mi-common-static-components';
import clsx from 'clsx';

export const TabContainerComp: FC<TabContainerProps> = props => {
  return (
    <StyledTabContainer data-testid="outdoors-TabContainer" data-component-name="o-outdoors-TabContainer">
      {props?.model?.styleclass?.toLowerCase()?.includes('outdoors-layout') ? (
        <div className={clsx(props?.model?.styleclass)}>
          <TabContainer
            {...props}
            key="outdoors-TabContainer"
            model={props?.model}
            isAuthorMode={props?.isAuthorMode}
            flexibleTabWidth={props?.model?.flexibleTabWidth}
            allowedComponents={props?.allowedComponents}
            tabsPerViewInDesktop={props?.model?.tabDetails?.length}
          />
        </div>
      ) : (
        <TabContainer {...props} isAuthorMode={props?.isAuthorMode} allowedComponents={props?.allowedComponents} />
      )}
    </StyledTabContainer>
  );
};

export const TabContainerConfig = {
  emptyLabel: 'TabContainer',
  isEmpty: () => true,
  resourceType: `mi-aem-common-spa/components/content/tabcontainer`,
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const TabEditableComponent = (props: any) => {
  return (
    <EditableComponent config={TabContainerConfig} {...props}>
      <TabContainerComp {...props} />
    </EditableComponent>
  );
};
